import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Completed from "../components/Completed";
import * as projectActions from "./../../../../../actions/project.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as tableActions from "./../../../../../actions/table.actions";
import * as userActions from "./../../../../../actions/user.actions";

const subHeader = {
  items: [
    {
      caption: "Matches",
      url: "/member/projects/completed"
    },
    {
      caption: "Pitches",
      url: "/member/projects/pitches"
    },
    {
      caption: "SOWs",
      url: "/member/projects/sows"
    },
    {
      caption: "Completed",
      url: "/member/projects/completed"
    },
    {
      caption: "Invoices",
      url: "/member/projects/invoices"
    }
  ],
  activeItem: 3,
  track: true
};

class CompletedContainer extends Component {
  constructor(props) {
    super(props);

    this.getCompletedProjects = this.getCompletedProjects.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProjects();
    this.props.commonActions.setSubHeader(subHeader);

    if (_.isEmpty(this.props.stats)) {
      this.props.userActions.getUserStats(3);
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
  }

  getCompletedProjects() {
    const projects = _.get(this.props, "projects");

    return (
      projects &&
      _.filter(projects, project => {
        const status = _.get(project, "status.name");
        return status === "completed" || status === "reviewed";
      })
    );
  }

  render() {
    const projects = this.getCompletedProjects();

    return projects && <Completed projects={projects} />;
  }
}

const mapStateToProps = state => {
  return {
    projects: state.project.projects,
    table: state.table
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    tableActions: bindActionCreators(tableActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompletedContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/completed/containers/CompletedContainer.js